import { Modelo } from '@ext/index';
import * as Types from './Atributos.types';
import moment, { Moment } from 'moment';
import { Guid } from 'guid-typescript';

export class IAtributo extends Modelo
{

    public constructor( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
        else
            this.nId = Guid.create().toString();
    }

    public Id: number = 0;
    public nId: string = '';
    public Articulo: string = '';
    public Atributo: string = '';
    public Descripcion: string = '';
    public Valor: string = '';
    public NoCorresponde: boolean = false;
    public PermiteNoCorresponde: boolean = false;
    public PorTitulo: boolean = false;


    public getJson(): any
    {
        let json: any = {};

        json.articulo = this.Articulo;
        json.atributo = this.Atributo;
        json.descripcion = this.Descripcion;
        json.valor = this.Valor;
        json.no_corresponde = this.NoCorresponde ? 'S' : 'N';


        return json;
    }


    public set(): boolean
    {

        this.Id = !this.Json.id ? 0 : this.Json.id;
        this.Articulo = !this.Json.articulo ? '' : this.Json.articulo;
        this.Atributo = !this.Json.atributo ? '' : this.Json.atributo;
        this.Descripcion = !this.Json.descripcion ? '' : this.Json.descripcion;
        this.Valor = !this.Json.valor ? '' : this.Json.valor;
        this.NoCorresponde = this.Json.no_corresponde == 'S';
        if ( this.NoCorresponde )
        {
            this.PermiteNoCorresponde = this.NoCorresponde;
            this.Valor = 'No corresponde';
        }


        this.Existe = true;
        return this.Existe;
    }

    public get Vista(): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor( Model: IAtributo )
    {
        this.Model = Model;
    }

    public Model: IAtributo;
}